import classNames from 'classnames'
import { Link } from 'gatsby'
import React, { useContext } from 'react'

import { LocaleContext, TranslationKey } from '../../locale/i18n'
import { IndustryOrMaterial, TypeOfTesting } from '../../logic/catalog'
import { ProductFilterType } from '../../logic/shared-types'
import IconCircledClear from '../icons/IconCircledClear'

const ProductCategoryTag = <
  Dimension extends
    | ProductFilterType.INDUSTRY_OR_MATERIAL
    | ProductFilterType.TYPE_OF_TESTING,
>({
  category,
  className,
  dimension,
  highlight,
  href,
  imgSize = 24,
  onClick,
  onDelete,
}: {
  category: Dimension extends ProductFilterType.INDUSTRY_OR_MATERIAL
    ? IndustryOrMaterial
    : TypeOfTesting
  dimension: Dimension
  className?: string
  highlight?: boolean
  href?: string
  imgSize?: number
  onClick?: React.MouseEventHandler
  onDelete?: () => void
}) => {
  const { t } = useContext(LocaleContext)

  const key: TranslationKey = `${dimension}.${category}` as TranslationKey
  const tagContent = (
    <>
      <img
        className="tag__icon"
        src={`/category-icons/${category as string}.svg`}
        width={imgSize}
        height={imgSize}
        alt={t(key)}
      />
      {t(key)}
      {onDelete && (
        <button className="tag__delete" onClick={onDelete}>
          <IconCircledClear stroke="#666" />
        </button>
      )}
    </>
  )

  return href ? (
    <Link
      className={classNames(
        'tag',
        'tag--clickable',
        { 'tag--highlight': highlight },
        className,
      )}
      onClick={onClick}
      to={href}
      state={{ scrollToOptions: { top: 0 } }}
      rel="nofollow"
    >
      {tagContent}
    </Link>
  ) : (
    <div
      className={classNames('tag', { 'tag--highlight': highlight }, className)}
      onClick={onClick}
    >
      {tagContent}
    </div>
  )
}

export default ProductCategoryTag
